import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import './Account.css';

function Account() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkUser = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        window.location.href = '/';
        return;
      }
      setUser(session.user);
      setLoading(false);
    };

    checkUser();
  }, []);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    window.location.href = '/';
  };

  if (loading) {
    return <div className="account-container">Loading...</div>;
  }

  if (!user) {
    return null;
  }

  return (
    <div className="account-container">
      <div className="account-card">
        <h1>Account Settings</h1>
        
        <div className="account-section">
          <h2>Account Information</h2>
          <div className="info-item">
            <label>Email:</label>
            <span>{user.email}</span>
          </div>
        </div>

        <div className="account-section">
          <button
            className="action-button secondary logout-button"
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}

export default Account;

